<eo-file-upload-base
  [id]="id"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [config]="getConfig()"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-fileUpload
    #fileUpload
    name="files{{ id }}[]"
    [showUploadButton]="false"
    [files]="files"
    [multiple]="getMultiple"
    [styleClass]="styleClass"
    [chooseLabel]="getChooseLabel"
    [chooseIcon]="getChooseIcon"
    [cancelIcon]="getCancelIcon"
    [cancelLabel]="getCancelLabel"
    [cancelStyleClass]="getCancelStyleClass"
    [removeStyleClass]="getRemoveStyleClass"
    [accept]="getAccept"
    [maxFileSize]="getMaxFileSize"
    [fileLimit]="getFileLimit"
    [invalidFileLimitMessageSummary]="getInvalidFileLimitMessageSummary"
    [invalidFileLimitMessageDetail]="getInvalidFileLimitMessageDetail"
    (onSelect)="onFilesSelect($event)"
    (onClear)="onFilesClear()"
  >
    <ng-template pTemplate="toolbar">
      <p-button
        *ngIf="getDownloadPrototypeVisible"
        outlined
        icon="pi pi-file"
        pTooltip="Προβολή Προτότυπου"
        (onClick)="onDowlnoadPrototype()"
      />
    </ng-template>

    <ng-template pTemplate="file" let-file let-i="index">
      <div
        class="flex justify-content-between align-items-center mb-3 p-3"
        [ngClass]="{ 'bg-gray-50': i % 2 == 1 }"
      >
        <div class="flex align-items-center gap-3">
          <p-image
            *ngIf="file"
            [src]="file.objectURL"
            [preview]="true"
            width="70"
          />
          {{ file.name }}
        </div>

        <p-button
          *ngIf="isRemoveFileVisible"
          outlined
          severity="danger"
          icon="pi pi-times"
          (onClick)="onFileRemove(file)"
        />
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div
        *ngIf="isDragAndDropPromtVisible"
        class="flex align-items-center justify-content-center flex-column"
      >
        <i class="pi pi-cloud-upload p-2 text-4xl text-400"></i>
        <p class="m-0 text-sm">{{ getDragAndDropSummary }}</p>
        <p class="m-0 text-xs">{{ getDragAndDropDescription }}</p>
      </div>
    </ng-template>
  </p-fileUpload>
</eo-file-upload-base>
